import { Dtos, formatAddress, SuretyAccountId } from "@inrev/common";
import { useGetAccountBondabilityLetter } from "@portal/api/account/agent";
import { Text } from "@portal/components/primitives";
import { TooltipButton } from "@portal/components/ui/TooltipButton";
import { HiArrowDownTray, HiOutlineBuildingOffice } from "react-icons/hi2";

export type AccountCompanyCardProps = {
	accountId: SuretyAccountId;
	company: Dtos.Company.Get.Response | Dtos.Admin.SuretyAccount.Get.Response.Company;
	options: {
		showPrequalButton: boolean;
		enablePrequalButton: boolean;
	};
};

export const AccountCompanyCard = ({ accountId, company, options }: AccountCompanyCardProps) => {
	const getAccountBondabilityLetter = useGetAccountBondabilityLetter(accountId);
	const { refetch, isFetching } = getAccountBondabilityLetter(company.id);

	return (
		<div
			key={company.id}
			className="w-full flex items-center py-[25px] px-[30px] border-b border-b-bc-default last:border-b-0"
		>
			<div className="flex flex-col flex-1 space-y-[15px]">
				<div className="flex flex-col space-y-[3px]">
					<div className="flex font-medium text-primary space-x-[10px]">
						<HiOutlineBuildingOffice className="text-primary mt-[4px] text-[18px]" />
						<span>{company.name}</span>
					</div>
					<Text type="body" color="secondary">
						{formatAddress(company.address)}
					</Text>
				</div>
			</div>
			<div className="flex flex-col space-y-[10px]">
				{options.showPrequalButton && (
					<TooltipButton
						color="secondary"
						shadow
						onClick={() => refetch()}
						loading={isFetching}
						disabled={isFetching || !options.enablePrequalButton}
						tooltip="Unavailable until account is approved"
					>
						<HiArrowDownTray className="text-[16px] text-secondary stroke-[.6] mr-[8px]" /> Prequal
						Letter
					</TooltipButton>
				)}
			</div>
		</div>
	);
};
